/** Textes « etatDesLieux » — le français fait foi. */
export const etatDesLieux = {
  accessoires: {
    cle: 'Clé', carteGrise: 'Carte grise', assurance: 'Assurance', vignette: 'Vignette',
    controleTechnique: 'Contrôle technique', giletTriangle: 'Gilet & triangle',
    crick: 'Crick', roueSecours: 'Roue de secours',
  } as Record<string, string>,
  /** Types de dommage : la clé stockée, telle qu'elle s'affiche en français. */
  typesDommage: { rayure: 'rayure', choc: 'choc', eclat: 'eclat', manquant: 'manquant' } as Record<string, string>,
  zones: { avant: 'avant', arriere: 'arriere', cote_gauche: 'cote gauche', cote_droit: 'cote droit' } as Record<string, string>,
  /** Carburant en quarts, index 0 à 4. */
  carburantQuarts: ['vide', '1/4', '1/2', '3/4', 'P'],
  supplements: {
    retard: 'Retard (article 02)',
    carburant_manquant: 'Carburant manquant (article 04)',
    km_supplementaire: 'Kilomètre supplémentaire (article 05)',
    nettoyage: 'Lavage partiel (article 03)',
  } as Record<string, string>,
  libelleFile: (retour: boolean, numero: string) => `État des lieux ${retour ? 'retour' : 'départ'} — ${numero}`,
  envoiPhotos: (faites: number, total: number) => `Envoi des photos ${faites}/${total}…`,
  erreurEnregistrement: 'Enregistrement impossible',
  rendus: (m: string) => `${m} rendus au client — l'écriture est en caisse.`,
  erreurRemboursement: "Le remboursement n'a pas abouti.",
  horsLigneTitre: 'Enregistré hors ligne',
  fileTitre: "Mis en file d'attente",
  horsLigneTexte: (n: number) => `Vous n'avez pas de réseau. L'état des lieux et ses ${n} photo(s) sont conservés sur ce téléphone et partiront tout seuls des que la connexion revient. Vous pouvez continuer a travailler.`,
  revenirTaches: 'Revenir a mes tâches',
  retourEnregistre: 'Retour enregistré',
  nouveauxDommages: (n: number) => `${n} nouveau(x) dommage(s)`,
  nouveauxDommagesTexte: "Constatés au retour, absents du départ. C'est la comparaison qui évite le litige.",
  supplementsAFacturer: 'Suppléments a facturer',
  nonChiffrable: 'Retour NON chiffrable — ne restituez pas la caution',
  absentsCatalogue: 'Ces suppléments prévus par votre contrat sont absents du catalogue, donc jamais calculés :',
  gerantDoitA: 'Un gérant doit les renseigner dans ',
  parametresSupplements: 'Paramètres › Suppléments',
  gerantDoitB: ' avant de solder ce retour.',
  totalIncompletA: ' Le total affiché ci-dessous est ',
  incomplet: 'incomplet',
  totalIncompletB: '.',
  aucunSupplement: 'Aucun supplément',
  conforme: 'Véhicule rendu conforme.',
  colSupplement: 'Supplément', colCalcul: 'Calcul', colMontant: 'Montant',
  totalSupplements: 'Total des suppléments',
  retourAnticipe: (n: number) => `Retour anticipé — ${n} jour(s) rendus`,
  finPrevue: (d: string) => `Fin prévue le ${d}`,
  verseA: (m: string) => `Le client a versé ${m}. Pour les jours qu'il ne prend pas, le logiciel propose de lui rendre`,
  verseB: '. Vous décidez du montant, ou vous ne rendez rien.',
  montantARendre: (devise: string) => `Montant à rendre (${devise})`,
  motifObligatoire: 'Motif (obligatoire)',
  motifPlaceholder: 'Retour anticipé — 3 jours non utilisés',
  rendre: (m: string) => `Rendre ${m}`,
  largent: "l'argent",
  aucunRemboursement: 'Aucun remboursement — la location reste due en entier.',
  neRienRendre: 'Ne rien rendre',
  anticipeTraite: 'Retour anticipé traité',
  voirDossier: 'Voir le dossier',
  encaisserSolde: 'Encaisser le solde',
  titre: (retour: boolean) => `État des lieux — ${retour ? 'retour' : 'départ'}`,
  saisieEnCours: 'Une saisie est déjà en cours sur cet appareil',
  etiezA: "Vous étiez à l'",
  etapeSur: (n: number) => `étape ${n} sur 5`,
  avec: ', avec ',
  photosN: (n: number) => `${n} photo(s)`,
  virgule: ', ',
  dommagesN: (n: number) => `${n} dommage(s)`,
  releves: ' relevé(s)',
  et: ', et ',
  laSigClient: 'la signature du client',
  celleAgent: "celle de l'agent",
  joinEt: ' et ',
  point: '.',
  reprendre: "Reprendre où j'en étais",
  recommencer: 'Tout recommencer',
  etape: (n: number) => `Étape ${n} sur 5`,
  auDepart: 'Au départ',
  resumeDepart: (date: string, km: string, u: string, carb: string, pi: number, pe: number, n: number) =>
    `${date} · ${km} ${u} · carburant ${carb} · propreté ${pi}/10 int. ${pe}/10 ext. · ${n} dommage(s) constaté(s)`,
  photos: 'Photos',
  dommages: 'Dommages',
  pointsGris: 'Les points gris sont ceux constatés au départ.',
  typeDommage: 'Type de dommage',
  commentaire: 'Commentaire',
  commentairePlaceholder: 'Rayure portière avant droite',
  annuler: 'Annuler',
  ajouter: 'Ajouter',
  retirer: 'retirer',
  carburantKmProprete: 'Carburant, kilométrage et propreté',
  dateRetour: 'Date et heure du retour',
  dateDepart: 'Date et heure du départ',
  momentAide: "Le moment réel, pas celui de la saisie. C'est lui qui compte pour un retard.",
  retardTitre: (heures: number, montant: string) =>
    `${heures} heure(s) de retard seront facturées${montant ? ` — ${montant}` : ''}`,
  retardDetail: (du: string, saisi: string) =>
    `La voiture était due le ${du}. Vous notez un retour le ${saisi}. Si ce n'est pas l'heure réelle à `
    + 'laquelle le client a rendu la voiture — par exemple parce que vous saisissez ce retour plus tard — '
    + "corrigez l'heure ci-dessus avant de valider.",
  carburant: 'Carburant',
  carburantAide: 'Les quatre cases de votre contrat papier (article 04)',
  kmCompteur: 'Kilométrage au compteur',
  kmAide: (depart: string, parcourus: string, u: string) => `Départ : ${depart} ${u} — soit ${parcourus} ${u} parcourus`,
  propreteInt: 'Propreté intérieure',
  propreteExt: 'Propreté extérieure',
  accessoiresTitre: 'Accessoires',
  observations: 'Observations',
  signatures: 'Signatures',
  sigClientLabel: 'Signature du client — précédé de « Lu et approuvé »',
  sigAgentLabel: "Signature du directeur / de l'agent",
  sigManquantes: 'Signatures manquantes',
  deuxManquent: 'Les deux signatures manquent.',
  clientManque: 'La signature du client manque.',
  votreManque: 'Votre signature manque.',
  sansElles: "Sans elles, ce document n'engage personne en cas de litige.",
  aucunePhoto: 'Aucune photo',
  aucunePhotoTexte: "L'état des lieux photographique est votre meilleure protection en cas de contestation sur un dommage. Prenez au moins les quatre côtés à l'étape 4.",
  sansPhoto: 'Je valide sans photo, en connaissance de cause',
  plusModifier: 'Une fois enregistré, vous ne pourrez plus modifier',
  verifiez: "Vérifiez avant de valider. En cas d'erreur, il faudra passer par une demande de correction.",
  retour: 'Retour',
  suivant: 'Suivant',
  enregistrement: 'Enregistrement…',
  validerRetour: 'Valider le retour',
  validerDepart: 'Valider le départ',
  recap: 'Récapitulatif',
  kilometrage: 'Kilométrage',
  proprete: 'Propreté',
  propreteValeur: (pi: number, pe: number) => `${pi}/10 int. · ${pe}/10 ext.`,
  accessoiresPresents: 'Accessoires présents',
  photosPrises: 'Photos prises',
  dommagesMarques: 'Dommages marqués',
  motClient: 'client',
  motAgent: 'agent',
};
